
import axiosServices from './request';

const MessageCenter = axiosServices('message');

export default {
  //发送手机验证码
  sendPhoneMessage: MessageCenter('post', 'shortMessage/sendPhoneMessageVerity'),

  //验证手机号
  validatePhoneNumber: MessageCenter('post', 'shortMessage/validate'),

  //邮件发送
  sendResourceDownloadEmail: MessageCenter('post', 'email/sendResourceDownloadEmail')

};
